import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private http: HttpService) { }

  createCompany(payload: any) {
    try {
      const company = this.http
        .post(`/company/create`, payload)
        .pipe(take(1))
        .toPromise();

      return company;
    } catch (error) {
      throw error;
    }
  }

  getCompany(id: string) {
    return this.http.get(`/company/${id}`);
  }

  getCompanyDeleted(limit?: number, page?: number, search?: string, startDate?: string, endDate?: string, type = 'ALL') {
    let filter = [];
    if (page) filter.push(`page=${page}`);
    if (limit) filter.push(`limit=${limit}`);
    if (search) filter.push(`search=${search}`);
    if (startDate) filter.push(`startDate=${startDate}`);
    if (endDate) filter.push(`endDate=${endDate}`);
    if (type) filter.push(`type=${type}`);

    console.log(`/company/companies-deleted${filter.join('&')}`)
    return this.http.get(`/company/companies-deleted?${filter.join('&')}`);
  }

  getCompanyHome(id: string) {
    return this.http.get(`/analytics/home?companyId=${id}`);
  }

  getMatrix() {
    return this.http.get(`/company`);
  }

  getMyCompany() {
    return this.http.get(`/company/my-company`);
  }

  getCompaniesList() {
    return this.http.get(`/company/companies-names`);
  }

  getMatrixKPI(id: string) {
    return this.http.get(`/analytics/enterprise-kpi/${id}`);
  }
  getTransactionsKPIById(id: string, startDate: string, endDate: string) {
    let filter = [];
    if (startDate) filter.push(`startDate=${startDate}`);
    if (endDate) filter.push(`endDate=${endDate}`);
    if (id) filter.push(`companyId=${id}`);
    return this.http.get(`/analytics/transactions-kpi-enterprise${filter.length > 0 ? '?' : ''}${filter.join('&')}`);
  }

  getTransactionsKPI(startDate: string, endDate: string) {
    let filter = [];
    if (startDate) filter.push(`startDate=${startDate}`);
    if (endDate) filter.push(`endDate=${endDate}`);
    return this.http.get(`/analytics/transactions-kpi-enterprise${filter.length > 0 ? '?' : ''}${filter.join('&')}`);
  }

  getMatrixBranches(id: string) {
    return this.http.get(`/branch/matrix/${id}`);
  }

  getBranchesByMatrix(
    id: string,
    rut?: string,
    startDate?: string,
    endDate?: string
  ) {
    let filtro = [];
    if (rut) filtro.push(`search=${rut}`);
    if (startDate) filtro.push(`startDate=${startDate}`);
    if (endDate) filtro.push(`endDate=${endDate}`);
    return this.http.get(
      `/branch/${id}${filtro.length != 0 ? '?' : ''}${filtro.join('&')}`
    );
  }

  assignFundToBranch(payload: any) {
    return this.http.post('/branch/assign-balance', payload);
  }

  getMatrixBranchesByMatrixAndDate(
    id: string,
    startDate?: string,
    endDate?: string,
    status?: string
  ) {
    let filtro = [];
    if (startDate) filtro.push(`startDate=${startDate}`);
    if (endDate) filtro.push(`endDate=${endDate}`);
    if (status) filtro.push(`status=${status}`);
    return this.http.get(
      `/branch/matrix/${id}${filtro.length != 0 ? '?' : ''}${filtro.join('&')}`
    );
  }

  getCompanyDetails(id: string) {
    return this.http.get(`/company/detail/${id}`);
  }

  getAll(id: any) {
    return this.http.get(`/company/my-companies?companyId=${id}`);
  }

  getLastTransactions() {
    return this.http.get(`/company/last-transactions`);
  }

  unblokedNotPay(id: any) {
    return this.http.patch(`/company/unblokedNotPay/${id}`);
  }
  blokedNotPay(id: any) {
    return this.http.patch(`/company/blokedNotPay/${id}`);
  }

  deleteStep1(id: any) {
    return this.http.delete(`/company/delete/step1/${id}`);
  }

  deleteStepUploadFile(payload: any) {
    return this.http.post(`/company/delete/step-upload`, payload);
  }

  deleteStep2(id: any) {
    return this.http.delete(`/company/delete/step2/${id}`);
  }

  deleteOneBranchStep1(id: any) {
    return this.http.delete(`/company/delete-branch/step1/${id}`);
  }

  deleteOneBranchStep2(token: any) {
    return this.http.delete(`/company/delete-branch/step2/${token}`);
  }

  deleteMultibleBranchesStep1(payload: any) {
    return this.http.post(`/company/delete-branchs/step1`, payload);
  }

  deleteMultibleBranchesStep2(payload: any) {
    return this.http.post(`/company/delete-branchs/step2`, payload);
  }

}
